import { TickerFinder } from "./TickerFinder";
import "./index.css";

export function App() {
  return <TickerFinder />;
}

export default App;
